__turbopack_context__.v({
  "ambient": "landing-module__leCHZG__ambient",
  "blue": "landing-module__leCHZG__blue",
  "connection": "landing-module__leCHZG__connection",
  "dotBlue": "landing-module__leCHZG__dotBlue",
  "dotGold": "landing-module__leCHZG__dotGold",
  "dotPink": "landing-module__leCHZG__dotPink",
  "eyebrow": "landing-module__leCHZG__eyebrow",
  "handoff": "landing-module__leCHZG__handoff",
  "handoffPanel": "landing-module__leCHZG__handoffPanel",
  "hero": "landing-module__leCHZG__hero",
  "heroActions": "landing-module__leCHZG__heroActions",
  "heroCopy": "landing-module__leCHZG__heroCopy",
  "heroFine": "landing-module__leCHZG__heroFine",
  "heroLead": "landing-module__leCHZG__heroLead",
  "howItWorks": "landing-module__leCHZG__howItWorks",
  "lensCard": "landing-module__leCHZG__lensCard",
  "lensGrid": "landing-module__leCHZG__lensGrid",
  "lensLabel": "landing-module__leCHZG__lensLabel",
  "liveState": "landing-module__leCHZG__liveState",
  "nav": "landing-module__leCHZG__nav",
  "navActions": "landing-module__leCHZG__navActions",
  "navCta": "landing-module__leCHZG__navCta",
  "navLogin": "landing-module__leCHZG__navLogin",
  "oracleAIBadge": "landing-module__leCHZG__oracleAIBadge",
  "oracleBubbleAI": "landing-module__leCHZG__oracleBubbleAI",
  "oracleBubbleUser": "landing-module__leCHZG__oracleBubbleUser",
  "oracleChat": "landing-module__leCHZG__oracleChat",
  "oracleDemo": "landing-module__leCHZG__oracleDemo",
  "oracleDemoSection": "landing-module__leCHZG__oracleDemoSection",
  "oracleExchange": "landing-module__leCHZG__oracleExchange",
  "orbitFrame": "landing-module__leCHZG__orbitFrame",
  "orbitInner": "landing-module__leCHZG__orbitInner",
  "orbitLegend": "landing-module__leCHZG__orbitLegend",
  "orbitLine": "landing-module__leCHZG__orbitLine",
  "orbitOuter": "landing-module__leCHZG__orbitOuter",
  "orbitRing": "landing-module__leCHZG__orbitRing",
  "orbitSvg": "landing-module__leCHZG__orbitSvg",
  "orbitTopline": "landing-module__leCHZG__orbitTopline",
  "pink": "landing-module__leCHZG__pink",
  "planetBlue": "landing-module__leCHZG__planetBlue",
  "planetGold": "landing-module__leCHZG__planetGold",
  "planetIcon": "landing-module__leCHZG__planetIcon",
  "planetLabel": "landing-module__leCHZG__planetLabel",
  "planetPink": "landing-module__leCHZG__planetPink",
  "primaryCta": "landing-module__leCHZG__primaryCta",
  "problem": "landing-module__leCHZG__problem",
  "problemCard": "landing-module__leCHZG__problemCard",
  "problemContent": "landing-module__leCHZG__problemContent",
  "problemGlyph": "landing-module__leCHZG__problemGlyph",
  "problemGrid": "landing-module__leCHZG__problemGrid",
  "scrollCue": "landing-module__leCHZG__scrollCue",
  "scrollCueIcon": "landing-module__leCHZG__scrollCueIcon",
  "scrollCueText": "landing-module__leCHZG__scrollCueText",
  "sectionIntro": "landing-module__leCHZG__sectionIntro",
  "shell": "landing-module__leCHZG__shell",
  "stepCard": "landing-module__leCHZG__stepCard",
  "stepNum": "landing-module__leCHZG__stepNum",
  "stepsGrid": "landing-module__leCHZG__stepsGrid",
  "story": "landing-module__leCHZG__story",
  "sunIcon": "landing-module__leCHZG__sunIcon",
  "testimonial": "landing-module__leCHZG__testimonial",
  "testimonialAttribution": "landing-module__leCHZG__testimonialAttribution",
  "testimonialPanel": "landing-module__leCHZG__testimonialPanel",
  "testimonialQuote": "landing-module__leCHZG__testimonialQuote",
  "testimonialStars": "landing-module__leCHZG__testimonialStars",
  "themeToggle": "landing-module__leCHZG__themeToggle",
  "trustBand": "landing-module__leCHZG__trustBand",
  "trustLabel": "landing-module__leCHZG__trustLabel",
  "trustStat": "landing-module__leCHZG__trustStat",
  "trustValue": "landing-module__leCHZG__trustValue",
  "violet": "landing-module__leCHZG__violet",
  "wordmark": "landing-module__leCHZG__wordmark",
  "wordmarkMark": "landing-module__leCHZG__wordmarkMark",
  "zodiacSign": "landing-module__leCHZG__zodiacSign",
});
